import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ProductEntity } from '@wg/wows-commerce/core/entity/product.entity';

import { loadProducts } from '~/store/wowsCommerce';


export interface State {
    products: ProductEntity[],
    isLoadingStore: boolean,
}

const initialState: State = {
    products: [],
    isLoadingStore: false,
};


export const wowsCommerceSlice = createSlice({
    name: 'wowsCommerce',
    initialState,
    reducers: {
        setShopLoadingState(state: State, action: PayloadAction<boolean>) {
            state.isLoadingStore = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadProducts.pending, (state) => {
                state.isLoadingStore = true;
            })
            .addCase(loadProducts.fulfilled, (state, action) => {
                state.products = action.payload;
                state.isLoadingStore = false;
            })
            .addCase(loadProducts.rejected, (state) => {
                state.isLoadingStore = false;
            });
    },
});

export default wowsCommerceSlice.reducer;


// All reducers for actions/middleware
export const wowsCommerceReducerActions = wowsCommerceSlice.actions;
